import React from 'react';
import LTTPodcastContent from "../FunctionComponents/PodCastFolder/LTTPodcastContent"

function LTTPodcast() {
  return (
    <>
    <LTTPodcastContent />
    </>
  )
}

export default LTTPodcast